import { createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import { Auth } from "../../firebase/auth";
import { RegisterInput, LoginInput } from "../../firebase/types";
import { formatError } from "../../utils";

export const register = createAsyncThunk(
    "auth/register",
    async (data: RegisterInput, { rejectWithValue }): Promise<any> => {
        try {
            let result = await Auth.signUpWithEmailAndPassword(data);
            notification.success({ placement: "top", message: "Registration Sucessful" });
            return result;
        } catch (error: any) {
            notification.error({ message: "Registration Failed", description: formatError(error.code) });
            return rejectWithValue("oops !!! something went wrong, please try again.");
        }
    }
);

export const socioLogin = createAsyncThunk(
    "auth/socioLogin",
    async (authType: "facebook" | "google", { rejectWithValue }): Promise<any> => {
        try {
            let result: any = null;

            if (authType === "facebook") {
                result = await Auth.signInWithFacebook();
            }

            if (authType === "google") {
                result = await Auth.signInWithGoogle();
            }

            notification.success({ placement: "top", message: "Login Sucessful" });

            return result;
        } catch (error: any) {
            notification.error({ message: "Login Failed", description: formatError(error.code) });
            return rejectWithValue("oops !!! something went wrong, please try again.");
        }
    }
);

export const login = createAsyncThunk("auth/login", async (data: LoginInput, { rejectWithValue }): Promise<any> => {
    try {
        let result = await Auth.loginWithEmailAndPassword(data);
        notification.success({ message: "Login Sucessful" });
        return result;
    } catch (err: any) {
        let msg = formatError(err.code);
        if (["auth/wrong-password", "auth/internal-error"].includes(err.code)) {
            msg = "Invalid login credentials";
        }
        if (err.code === "auth/user-not-found") {
            msg = "You do not have an account, kindly sign up below";
        }
        notification.error({ message: "Login Failed", description: msg });
        return rejectWithValue("oops !!! something went wrong, please try again.");
    }
});

export const updateProfile = createAsyncThunk(
    "auth/updateProfile",
    async ({ userId, data }: { userId: any; data: any }, { rejectWithValue }): Promise<any> => {
        try {
            let result = await Auth.updateProfile(userId, data);
            notification.success({ placement: "top", message: "Changes saved sucessfully" });
            return result;
        } catch (err: any) {
            notification.error({
                message: "An error occurred",
                description: "oops !!! something went wrong, please try again.",
            });
            return rejectWithValue("oops !!! something went wrong, please try again.");
        }
    }
);

export const logOut = createAsyncThunk("auth/logout", async (): Promise<any> => {
    try {
        await Auth.signOut();
    } catch (error) {
        console.log(error);
    }
});
